exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.classth th[data-v-6d985fcd] {\n    font-weight: bold !important;\n}\n.classthDiscount th[data-v-6d985fcd] {\n    font-weight: bold i !important;\n}\n.modal-height[data-v-6d985fcd] {\n    height:350px;\n}\n@media only screen and (max-width: 639px) {\n.modal-height[data-v-6d985fcd] {\n        height:500px;\n}\n}\n", ""]);

// exports
